import { render } from "./AdminTestDataInsertView.vue?vue&type=template&id=6e923e53&scoped=true"
import script from "./AdminTestDataInsertView.vue?vue&type=script&lang=js"
export * from "./AdminTestDataInsertView.vue?vue&type=script&lang=js"

import "./AdminTestDataInsertView.vue?vue&type=style&index=0&id=6e923e53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e923e53"]])

export default __exports__